import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
import { AddToCartService } from '../../_shared/services/add-to-cart.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.css']
})
export class VerifyOtpComponent implements OnInit {
  baseUrl: any = environment.apiUrl;
  signupDetails: any;
  customerId: any;
  otp: any;
  submittedOtp: any;
  invalidOTP: boolean = false;
  otpSent: boolean = false;

  constructor(private service: CommonHttpService, private addToCartService: AddToCartService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { }

  ngOnInit() {
    window.scrollTo(0,0)
    this.signupDetails = JSON.parse(localStorage.getItem('signupDetails'));
    this.sendOTP()
  }

  submit(){
    if(this.otp == this.submittedOtp){
      this.invalidOTP = false
      this.signup()      
    }
    else{
      this.invalidOTP = true
    }
  }

  //generateOTP(){
    //this.otp = Math.floor(1000 + Math.random() * 9000);
    //this.service.update(this.baseUrl + 'CustomerAPI/OTPUpdate/' + this.customerId + '?Otp=' + this.otp, {})
      //.subscribe(
        //data => {
          //console.log(data)
          //this.sendOTP()
        //},
        //(error) => {
          //this.loaderService.display(false);
        //})

  //}

  sendOTP(){
    this.otp = Math.floor(1000 + Math.random() * 9000);
    let sendData = { CustomerMobile : this.signupDetails.MobileNumber, TextMsg: "Use " + this.otp + " as your login OTP. OTP is confidential. Nowgrocery never calls you asking for OTP. Sharing it with anyone gives them full access to your Nowgrocery Account"}

    this.service.create(this.baseUrl + 'SMSAPI/SendSMS', sendData)
      .subscribe(
        data => {
          this.otpSent = true;
          console.log(data)
        },
        (error) => {
          this.loaderService.display(false);
        })
  }

  signup(){
    this.loaderService.display(true);
    this.service.create(this.baseUrl + 'ESignUpAPI/Signup', this.signupDetails)
      .subscribe(
        data => {
          console.log(data)
          this.customerId = data
          this.addReferralPoints()
          localStorage.setItem('customerName', this.signupDetails.CustomerName);
          localStorage.setItem('customerId', this.customerId);
          localStorage.setItem('isLoggedin', 'true');
          this.addToCartService.getCartDetailsAfterLogin();
          //this.router.navigate([''])      
          //this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        })
  }

  addReferralPoints(){
    let sendData = { CustomerId: Number(this.customerId), NowPoints: 0, RefferalPoints: 1000}
    this.service.create(this.baseUrl + 'ReturnAPI/EditNowPoints/' + Number(this.customerId), sendData)
      .subscribe(
      data => {
      },
      (error) => {
      });
  }

}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/verify-otp/verify-otp.component.ts